"use strict";
var swiper = new Swiper(".swiper", {
    spaceBetween: 50,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});
var popupButtons = document.querySelectorAll(".materials__popup-btn");
var popups = document.querySelectorAll(".materials__popup");
popupButtons.forEach(function(popupButton, index) {
    popupButton.addEventListener("click", function(event) {
        event.preventDefault();
        var isActive = popupButton.classList.contains("materials__popup-btn--active");
        // eslint-disable-next-line no-shadow
        popupButtons.forEach(function(popupButton) {
            popupButton.classList.remove("materials__popup-btn--active");
        });
        popups.forEach(function(popup) {
            popup.classList.remove("materials__popup--active");
        });
        if (!isActive) {
            popupButton.classList.add("materials__popup-btn--active");
            popups[index].classList.add("materials__popup--active");
        }
    });
});

//# sourceMappingURL=index.74f29227.js.map
